import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { ClusterApprovalRequest } from '../../types/cluster'

const { CLUSTERS_API_URL } = CONSTANT

const acceptCluster = async (
	clusterApproval: ClusterApprovalRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${CLUSTERS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'APPROVE'
		},
		body: JSON.stringify(clusterApproval)
	})
	return response.json()
}

export default acceptCluster
